import { render, staticRenderFns } from "./ActivityLogList.vue?vue&type=template&id=144df054&scoped=true"
import script from "./ActivityLogList.vue?vue&type=script&lang=ts"
export * from "./ActivityLogList.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLogList.vue?vue&type=style&index=0&id=144df054&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144df054",
  null
  
)

export default component.exports